<template>
  <van-cell :title="label" :required="required" class="field-upload">
    <!-- <van-uploader
      v-model="imageList"
      :multiple="false"
      :max-count="1"
      :before-read="beforeUpload"
      :after-read="afterUpload"
    ></van-uploader> -->
    <template v-if="localDatas.length">
      <div v-for="(item, index) in localDatas" :key="index" class="upload-wrap">
        <van-image fit="cover" :src="item" />
        <van-icon name="clear" class="icon-del" @click="delImg(index)"/>
      </div>
    </template>
    <span v-else @click="onUploadClick" class="upload-wrap">
      <van-icon name="plus" />
    </span>
  </van-cell>
</template>
<script lang="ts" setup>
import { showToast } from 'vant';
import { ref, watch, computed } from 'vue';
import { chooseImage, validateImage, uploadImage } from '@/utils/wxSDK/uploadImage';

const props = defineProps({
  label: String,
  required: Boolean,
  modelValue: String,
})

const emit = defineEmits(['update:modelValue'])

// const imageList = ref<string[]>([]);

const localDatas = ref<string[]>([]);

const localDataIdMap = ref<Record<string, string>>({});

onMounted(() => {
  setLocalData();
})

// 使用watch监听props.value的变化
watch(() => props.modelValue, (newValue) => {
  setLocalData();
});

// 设置localDatas，回显图片
const setLocalData = () => {
  if (!props.modelValue) {
    localDatas.value = [];
    localDataIdMap.value = {};
    return;
  }
  if (!localDataIdMap.value[props.modelValue]) {
    localDatas.value = [props.modelValue];
    return;
  }
}

// 选择图片
const onUploadClick = async () => {
  // 选择图片
  const localIds = await chooseImage(1);
  if (!localIds.length) return;
  const localId = localIds[0];
  // 校验图片格式大小， localData用于回显图片
  const { pass, localData } = await validateImage(localId);
  if (!pass || !localData) return;
  localDatas.value = [localData];
  // 上传至微信，获取mediaId
  const serverId = await uploadImage(localId);
  localDataIdMap.value = { [serverId]: localId };
  emit('update:modelValue', serverId);
}

// 删除图片
const delImg = (index: number) => {
  localDatas.value.splice(index, 1);
  localDataIdMap.value = {};
  emit('update:modelValue', '');
}

const beforeUpload = (file) => {
  console.log(file)
  if (!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
    showToast('上传失败，图片格式必须为jpg、jpeg、png');
    return false;
  }
  if (file.size > 1024 * 1024 * 10) {
    showToast('上传失败，图片大小不能超过10M');
    return false;
  }
  return true;
}

const afterUpload = (files, detail) => {
  console.log(files, detail)
  // files.forEach(element => {
  //   // 模拟请求上传图片接口操作
  //   setTimeout(() => {
  //     element.status = null; // 上传成功后须将file对象的status属性置为null，否则遮罩不会消失。
  //   }, 2000);
  // });
  console.log(imageList.value)
}
</script>

<style scoped lang="less">
/* 添加一些样式以适应你的需求 */
.field-upload {
  &.van-cell--required {
    padding-left: 54px;
    &::before {
      left: 32px;
    }
  }
  /deep/.van-cell__value{
    display: flex;
    justify-content: flex-end;
  }
}
.upload-wrap {
  width: 200px;
  height: 200px;
  display: inline-block;
  border: solid 2px #e0e0e0;
  color: #bdbdbd;
  text-align: center;
  line-height: 200px;
  display: inline-block;
  position: relative;
  margin: 20px 20px 0 0;
  .van-image {
    width: 100%;
    height: 100%;
  }
  .icon-del {
    position: absolute;
    right: -20px;
    top: -20px;
  }
}
</style>
